import { PAY_CARD_STATE } from '@/features/paycard/types';
import { useKioskSession } from '@/lib/kioskSession';

/**
 * **Does this visit know of a pay card on the candidate's record?** — the question the application tail
 * asks before the pay-card step [KPC-1f; decision 0470], and the arrival menu's pay-card row asks to choose
 * between E7 and R1 [Operator, 2026-10-16, to be recorded as decision 0508].
 *
 * `true` in exactly two cases, and nowhere else:
 *
 * - **the lookup said so** — `payCardOnFile: true`, read once at identification [AC-1, AC-2];
 * - **a pay-card write succeeded in this visit** — `PAY_CARD_STATE.registered`, which `PayCardScreen` sets
 *   only when the proxy id reached Bullhorn, typically from the arrival menu's *Link pay card* [AC-6]. A
 *   rejected write sets nothing and an unanswered one sets `handedToRecruiter`, so neither counts.
 *
 * ⛔ **Fail OPEN: anything else is `false`** — `false`, `null`, a missing key, or no lookup state at all
 * [AC-3, AC-4; 0291]. Skipping the step on doubt would let a candidate with no card leave without one [0089].
 * ⛔ **Never new-or-returning**: the record decides, not the diagnosis [0470].
 *
 * It reads state; the screens decide. ⚠️ KPC-1f AC-7 — *"the arrival-menu path is unchanged"* — no longer
 * holds: the menu's row reads this too, `true` → E7, anything else → R1 [0508 supersedes it there].
 */
export function usePayCardOnFile(): boolean {
  return useKioskSession(
    (state) =>
      state.payCard === PAY_CARD_STATE.registered || state.lookupResult?.payCardOnFile === true,
  );
}
